/**
 * Global loaders.gl configuration to suppress deprecated warnings
 * and ensure proper MVTLoader configuration
 */

// Set global loaders configuration for MVT
if (typeof globalThis !== 'undefined') {
  // Configure global loaders.gl defaults
  (globalThis as any).loaders = {
    ...((globalThis as any).loaders || {}),
    gl: {
      ...((globalThis as any).loaders?.gl || {}),
      debug: false // Disable debug logging
    },
    _loadersgl: {
      ...((globalThis as any).loaders?._loadersgl || {}),
      MVTLoader: {
        mvt: {
          shape: 'geojson',
          coordinates: 'wgs84'
        },
        // Explicitly disable deprecated options
        gis: undefined
      }
    }
  };

  // Also set on window for web workers
  if (typeof window !== 'undefined') {
    (window as any).loadersgl_config = {
      MVTLoader: {
        mvt: {
          shape: 'geojson',
          coordinates: 'wgs84'
        }
      }
    };
  }
}

// Export configuration for use in services
export const MVT_LOADER_CONFIG = {
  mvt: {
    shape: 'geojson' as const,
    coordinates: 'wgs84' as const
  },
  // Explicitly disable deprecated options
  gis: undefined
};
